<template>
  <div>
    <div class="logo-search">
      <h1 class="logo">
        <a class="logoImg" href="http://file.xdf.cn/brand/brand.html"></a>
      </h1>
      <city-mask></city-mask>
      <div class="phone">
        <img src="http://images.xdf.cn/cms20150819/zuixinban/images/tel_phone_gw.png?20190410" />
        <span>{{ phoneNum }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getPhoneNumber } from 'js/getSoukeData.js'
import CityMask from '@/common-components/Citymask'
import CitySelect from '@/common-components/Cityselect'
export default {
  name: 'Logotitle',
  components: {
    CityMask,
    CitySelect
  },
  data () {
    return {
      phoneNum: '',
      searchVal: ''
    }
  },
  computed: {
    cityId () {
      return this.soukecityId
    },
    ...mapState(['soukecityId', 'cityName'])
  },
  created () {
    if (this.cityId) {
      this.getPhoneNum(this.cityId)
    }
  },
  watch: {
    cityId (newVal) {
      if (newVal) {
        this.getPhoneNum(newVal)
      }
    }
  },
  methods: {
    getPhoneNum (cityId) {
      getPhoneNumber(cityId).then(res => {
        this.phoneNum = res.Telephone
      })
    },
    soukechId () {
      window.open(`http://souke1.xdf.cn/Search.aspx?cid=${this.cityId}&kw=${this.searchVal}`)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.logo-search
  width: $defaultwidth
  margin: $defaultmargin
  font-size: 14px
  vertically()
  .logo
    vertically()
    .logoImg
      height: 112px
      width: 146px
      background-color: $fontcolor
      text-align: center
      line-height: 126px
      background: url(http://file.xdf.cn/neworiental/images/newlogo.png) no-repeat 5px 30px;
      vertically()
  div
    flex: 1
  .phone
    float: $fr
    line-height: 35px
    text-align: right
    width: 172px
    color: #f7ab00
    font-family: Arial
    font-size: 20px
    flex: none
    position: relative
    top: 6px
    img
      position: relative
      left: 2px
    span
      min-width: 128px
</style>



// WEBPACK FOOTER //
// src/pages/home/components/logo-search/Logosearch.vue